import { CategoryAPIData } from '../../../../types/growth-api';
import { AgendaTopicDTO } from './agenda-topic';

export class CategoryDTO {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	data: CategoryAPIData;

	agendaTopics: AgendaTopicDTO[];

	constructor(data: CategoryAPIData) {
		this.data = data;

		this.id = data.id;
		this.createdAt = new Date(data.created_at);
		this.updatedAt = new Date(data.updated_at);
		this.name = data.name;
		this.agendaTopics = data.agenda_topics.map((topic) => new AgendaTopicDTO(topic));
	}
}
